import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Landlords/PendingPaymentTable";
import SummaryCard from "../../Components/Landlords/SummaryForPendingRent";
import { toast } from "react-toastify";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import MarkAsPaidOfflineModal from "../../Components/Expenses/MarkAsPaidOfflineModal";
import { LargeSummarySkeletonLoading } from "../../Components/SkeletonLoading";
import SearchFilterBox from "../../Components/SearchFilterBox";
import ViewTransDetails from "../../Components/Landlords/ViewTransDetails";
import SideModal from "../../Components/SideModal";
import MarkAsPaidOnlineModal from "../../Components/Landlords/MarkAsPaidOnlineModal";

const PendingDues = () => {
  const searchOptions = [
    { label: "Name", value: 1 },
    { label: "Mobile", value: 2 },
    { label: "Property", value: 3 },
  ];

  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [masterData, setMasterData] = useState();
  const [apiData, setApiData] = useState();
  const [summary, setSummary] = useState();
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [expenseData, setExpenseData] = useState([]);
  const [isOnlineMarkPaidOpen, setIsOnlineMarkPaidOpen] = useState(false);
  const [isOfflineMarkPaidOpen, setIsOfflineMarkPaidOpen] = useState(false);

  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );

  const [viewDetail, setViewDetail] = useState(false);

  const query = `&s=${searchQuery}&t=${filterType}`;

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/landlord/list/unPaidDues?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) error = true;
    else {
      setApiData(res?.list);
      setMasterData(res?.list);
      setSummary(res?.summary);
      setIsFocused(true);
      fetchInitData();
    }
  };

  const getError = (res) => { };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      // setIsFocused(false);
      getListMutate();
    }, 200);

    return () => {
      clearTimeout(handler);
    };
  }, [property]);

  const fetchInitData = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/expense/initial-values`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    setExpenseData(response.data.data);
  };


  const handleFilterChange = (values) => {
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
    const handler = setTimeout(() => {
      getListMutate();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  };

  const handleClearFilters = () => {
    setFilterType("");
    setSearchQuery("");
    const handler = setTimeout(() => {
      getListMutate();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  };

  const onSummaryBoxClick = (data) => {

    let filteredData;

    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();

    if (data === "CMS" || data === "TD") {
      // Security
      filteredData = masterData.filter(
        (transaction) => transaction.type === 43
      );
    }
    else if (data === "CMR") {
      // Rent
      filteredData = masterData.filter(
        (transaction) => transaction.type === 1
      );
    }
    else if (data === "CMRP") {
      // Rent + Current Month (both conditions mandatory)
      filteredData = masterData.filter((transaction) => {
        if (!transaction.dueDate) return false;

        const dueDate = new Date(transaction.dueDate);

        return (
          transaction.type === 1 &&
          dueDate.getMonth() === currentMonth &&
          dueDate.getFullYear() === currentYear
        );
      });
    }
    else if (data === "App") {
      // Online using Kipinn App
      filteredData = masterData.filter(
        (transaction) => transaction.recordedBy === "Kipinn App"
      );
    }
    else {
      filteredData = masterData;
    }

    setApiData(filteredData);
  };


  //------- Pay rent to Landlord -------
  const onlineMarkAsPaidFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/landlord/payment/init`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const markAsPaidSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      if (data?.data?.link) {
        setIsOnlineMarkPaidOpen(false);
        window.open(data.data.link, "_blank", "noopener,noreferrer");
      }
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const markAsPaidError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: onlineMarkAsPaidLoading, mutate: onlineMarkAsPaidMutate } =
    useMutation(onlineMarkAsPaidFunction, {
      onSuccess: markAsPaidSuccess,
      onError: markAsPaidError,
    });

  //------- Mark As Paid Expense -------
  const offlineMarkPaidFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/expense/mark/paidx`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onMarkPaidExpenseSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
      setIsOfflineMarkPaidOpen(false);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onMarkPaidExpenseError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: offlineMarkPaidLoading, mutate: offlineMarkPaidMutate } =
    useMutation(offlineMarkPaidFunction, {
      onSuccess: onMarkPaidExpenseSuccess,
      onError: onMarkPaidExpenseError,
    });

  const handleMarkAsPaid = (row) => {
    setSelectedData (row);
    setIsOnlineMarkPaidOpen(false);
    setIsOfflineMarkPaidOpen (false);
    if (row?.canPayOnline) {
      setIsOnlineMarkPaidOpen(true);
    }
    else {
      setIsOfflineMarkPaidOpen(true);
    }
  }

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Pending Dues
            <Underline />
          </BoxTitle>
        </BoxHead>

        <SideModal
          isOpen={isOnlineMarkPaidOpen && !!selectedData}
          onClose={() => setIsOnlineMarkPaidOpen(false)}
        >
          <MarkAsPaidOnlineModal
            handleClose={() => setIsOnlineMarkPaidOpen (false)}
            onlineMarkAsPaidMutate={onlineMarkAsPaidMutate}
            onlineMarkAsPaidLoading={onlineMarkAsPaidLoading}
            selectedData={selectedData}
            selectedExpense={selectedExpense}
          />
        </SideModal>

        <SideModal
          isOpen={isOfflineMarkPaidOpen && !!selectedData}
          onClose={() => setIsOfflineMarkPaidOpen(false)}
        >
          <MarkAsPaidOfflineModal
            handleClose={() => setIsOfflineMarkPaidOpen(false)}
            markPaidExpenseLoading={offlineMarkPaidLoading}
            markPaidExpenseMutate={offlineMarkPaidMutate}
            selectedData={selectedData}
            expenseData={expenseData}
          />
        </SideModal>

        <SideModal
          isOpen={viewDetail}
          onClose={() => setViewDetail(false)}
        >
          <ViewTransDetails
            setViewDetail={setViewDetail}
            selectedData={selectedData}
            landlordName={selectedData?.landlordName || ""}
            landlordMobile={selectedData?.landlordMobile || ""}
          />
        </SideModal>

        {(isLoading || isRefetching) && !isFocused && (
          <LargeSummarySkeletonLoading count={3} />
        )}
        {isFocused && summary && (
          <>
            <SummaryCard summaryData={summary} onClick={onSummaryBoxClick} />
            <FilterTableWrapper>
              <FilterWrapper>
                <div className="flex md:space-x-4 md:flex-row flex-col md:gap-0 gap-4">
                  <SearchFilterBox
                    options={searchOptions}
                    handleFilterChange={handleFilterChange}
                    handleClearFilters={handleClearFilters}
                  />
                </div>
              </FilterWrapper>
              {!error && !isLoading && data && (
                <TableWrapper>
                  <Table
                    apiData={error ? [] : apiData}
                    setSelectedData={setSelectedData}
                    handleMarkAsPaid={(row) => handleMarkAsPaid (row)}
                  />
                  {(error || apiData.length === 0) && !isLoading && (
                    <NotFoundModel />
                  )}
                </TableWrapper>
              )}
            </FilterTableWrapper>
          </>
        )}
        {error && !isLoading && <NotFoundModel />}
        {(isLoading || isRefetching) && <Loading />}
      </BoxContainer>
    </>
  );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md`;

export default PendingDues;
